import React, {useRef} from 'react'

import GDProjectName from "../../../gd-ui/project-name/project-name"
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import RelatedItemIcon from "../../related-items/common/icon"
import EntitySelectorItem from "./item"

type Props = {
    model: EntitySelectorItem
}

// Icon + name + the project chip, the one title row every list tab shares.
//
// The icon is the related-items one: it already maps every entity type this
// selector can offer (and is what the linked row will show afterwards), so a
// second per-type switch here would only be a way to drift from it.
export default function EntitySelectorGlistTitleCell(props: Props) {

    const titleRef = useRef<HTMLDivElement>(null)

    // Full title on hover, only when the cell actually cut it off.
    const checkShowHint = () => {
        return !!titleRef.current
            && titleRef.current.scrollWidth > titleRef.current.clientWidth
    }

    return (
        <div className  = "flex-row-left-center txt-truncate m-l-8"
             style      = {{
                 width: "calc(100% - 8px)"
             }}
        >
            <RelatedItemIcon
                entity      = {props.model.entity}
                className   = "m-r-8"
            />

            <div ref        = {titleRef}
                 className  = "ui5-txt-default txt-truncate"
            >
                {props.model.title}

                <HintPopover
                    hint            = {props.model.title}
                    multiline       = {true}
                    checkShowHint   = {checkShowHint}
                />
            </div>

            {!!props.model.projectId &&
                <GDProjectName
                    className   = "m-l-10 max-w-50-percent"
                    type        = "ui5-prop"
                    projectId   = {props.model.projectId}
                />
            }
        </div>
    )
}
